import { EpgApi } from '../../../api/EpgApi';
import { EpgDetailDataSource } from './EpgDetailDataSource';
import { EpgUtil } from '../../utility/EpgUtil';
import { AssetType } from '../../../api/models/Shared.types';
import { Backend } from '../../../api/Backend';
import { IProgram, ISeriesDetail } from '../../../api/models/AndromeTV.types';

export class ProgramDetailDataSource extends EpgDetailDataSource {
  private scheduleHint: string | undefined;
  constructor(backend: Backend, scheduleHint: string | undefined = undefined) {
    super(backend);
    this.pageType = AssetType.PROGRAM;
    this.scheduleHint = scheduleHint;
  }

  override load(programId: string) {
    return this.initChannels().then(() => {
      const fromuntil = EpgUtil.epgFromUntil(this.backend);
      return EpgApi.program(
        this.backend,
        programId,
        fromuntil.from,
        fromuntil.until,
        this.backend.deviceProfile?.profile.catalog
      )
        .then((program: IProgram) => {
          this.program = program.program;
          if (program.series?.title) {
            this.series = program.series as ISeriesDetail;
          }
          this.season = program.season;

          if (this.scheduleHint) this.schedule = program.schedules?.find(s => s.id === this.scheduleHint);
          if (!this.schedule && this.channelsList)
            this.schedule = EpgUtil.findClosestSchedule(program.schedules, false, this.channelsList);

          if (this.schedule) {
            this.channel = this.channelsList?.find(channel => channel.channelId === this.schedule?.channel);
          } else {
            this.channel = undefined;
          }

          return this.findRecordingForProgram();
        })
        .then(() => {
          return super.load(programId);
        });
    });
  }
}
